var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabSettingsWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#36F6FF",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3316 13.2781C14.0674 11.8572 17.5485 10.5464 20.7962 9.74753C21.7463 9.51378 22.7281 9.86532 23.2222 10.7096C23.5751 11.3127 24.0059 12.1396 24.4615 13.2203M21.321 22.2651C21.3646 23.2413 22.1171 23.9687 23.0929 24.0077C23.5902 24.0278 24.2085 24.042 24.9583 24.042C25.7082 24.042 26.3265 24.0278 26.8238 24.0077C27.8 23.9687 28.5521 23.2413 28.5957 22.2651C28.6131 21.8677 28.625 21.3924 28.625 20.8337C28.625 20.275 28.6131 19.7997 28.5957 19.4023C28.5521 18.4261 27.7996 17.6987 26.8238 17.6597C26.2022 17.6359 25.5803 17.6244 24.9583 17.6254C24.2085 17.6254 23.5902 17.6396 23.0929 17.6597C22.1167 17.6987 21.3646 18.4261 21.321 19.4023C21.3007 19.8792 21.291 20.3564 21.2917 20.8337C21.2917 21.3929 21.3036 21.8677 21.321 22.2651Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7339 17.656C26.7053 16.8895 26.6605 16.1236 26.5996 15.3589C26.5043 14.1897 25.5963 13.3101 24.4262 13.229C23.0787 13.1355 20.9997 13.042 18.0833 13.042C15.167 13.042 13.0875 13.1355 11.74 13.229C10.5703 13.3097 9.66237 14.1897 9.56704 15.3589C9.4685 16.5661 9.375 18.3646 9.375 20.8337C9.375 23.3027 9.4685 25.1007 9.56704 26.3084C9.66237 27.4777 10.5703 28.3572 11.7405 28.4383C13.0875 28.5318 15.167 28.6253 18.0833 28.6253C20.9997 28.6253 23.0792 28.5318 24.4262 28.4383C25.5963 28.3577 26.5043 27.4777 26.5996 26.3084C26.6496 25.6975 26.6982 24.9353 26.7339 24.0113M24.5 20.3753V21.292",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabSettingsWalletIcon);
export default __webpack_public_path__ + "static/media/tc_cab_settings_wallet_icon.7267336a1408621247c15068b8ea5874.svg";
export { ForwardRef as ReactComponent };